import { useState } from "react";

function StarReview({ setSelectedStar, selectedStar }) {
  const [hoverStar, setHoverStar] = useState(0);

  // ⭐ Geometry map for each star layout
  const starShapes = {
    1: [{ g: "translate(15,15) scale(0.6)", polygons: ["translate(0,0)"] }],
    2: [
      {
        g: "translate(15,15) scale(0.5)",
        polygons: ["translate(-7,-7) ", "translate(7,7) "],
      },
    ],
    3: [
      {
        g: "translate(15,15)  scale(0.4)",
        polygons: ["translate(0,-10) ", "translate(-10,7) ", "translate(10,7)"],
      },
    ],
    4: [
      {
        g: "translate(15,15) scale(0.4)",
        polygons: [
          "translate(-10,-10) ",
          "translate(10,-10) ",
          "translate(10,10) ",
          "translate(-10,10) ",
        ],
      },
    ],
    5: [
      {
        g: "translate(15,15)  scale(0.4)",
        polygons: [
          "translate(0,-14)",
          "translate(-14,-3) ",
          "translate(14,-3) ",
          "translate(8,13) ",
          "translate(-8,13)",
        ],
      },
    ],
  };

  const handleSelectFiledStar = (star) => {
    setSelectedStar(selectedStar === star ? 0 : star);
  };

  const getColor = (star) =>
    hoverStar >= star || selectedStar >= star ? "#fc9700" : "none";

  const getStroke = (star) =>
    hoverStar >= star || selectedStar >= star ? "#cc4e00" : "black";

  const getFill = (star) =>
    hoverStar >= star || selectedStar >= star ? "#cc4e00" : "black";

  return (
    <div style={{ display: "flex", gap: "6px" }}>
      {[1, 2, 3, 4, 5].map((star) => (
        <div
          key={star}
          className="prod-star-wrapper"
          onClick={() => handleSelectFiledStar(star)}
          onMouseEnter={() => setHoverStar(star)}
          onMouseLeave={() => setHoverStar(0)}
          style={{ cursor: "pointer" }}
        >
          <svg width="30" height="30" viewBox="0 0 30 30">
            <circle
              cx="15"
              cy="15"
              r="13"
              stroke={getStroke(star)}
              strokeWidth="2"
              fill={getColor(star)}
            />
            {starShapes[star].map((group, gi) => (
              <g key={gi} transform={group.g}>
                {group.polygons.map((transform, pi) => (
                  <polygon
                    key={pi}
                    points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
                    fill={getFill(star)}
                    transform={transform}
                  />
                ))}
              </g>
            ))}
          </svg>
        </div>
      ))}
    </div>
  );
}

export default StarReview;
